import { useDispatch, useSelector } from 'react-redux';
import { useMutation } from '@apollo/client';
import { REMOVE_CART_PRODUCT_VARIANT } from '../../../../server';
import { cartSlice, StoreState } from '../../../redux';
import { Cart } from '@hiwaldo/sdk/interfaces';
import { modernVersionBridge } from '../../../utils';

type RemoveCartProductVariantEffectReturn = {
  removeCartProductVariant: (id: number) => void;
  loading: boolean;
  success: boolean;
  error: string | undefined;
};

export const useRemoveCartProductVariantEffect = (
  callback?: () => void
): RemoveCartProductVariantEffectReturn => {
  const dispatch = useDispatch();

  const { basketDataState } = useSelector((state: StoreState) => ({
    basketDataState: state.data.basket,
  }));

  const [doRemoveCartProductVariant, { loading, called, error }] = useMutation(
    REMOVE_CART_PRODUCT_VARIANT,
    {
      fetchPolicy: 'no-cache',
      onCompleted: (data) => {
        dispatch(cartSlice.actions.updateCart(data.removeCartProductVariant));
        modernVersionBridge.basket.updateCart(
          dispatch,
          basketDataState,
          data.removeCartProductVariant as Cart
        );
        if (callback) {
          callback();
        }
      },
    }
  );

  const removeCartProductVariant = (id: number): void => {
    modernVersionBridge.basket.loading(dispatch, basketDataState, true);

    const variables = { id };

    doRemoveCartProductVariant({ variables }).then();
  };

  const success = !loading && called && !error;

  return {
    removeCartProductVariant,
    loading,
    success,
    error: error?.message,
  };
};
